import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Star, Sparkles } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-24 pb-20 md:pt-48 md:pb-32 overflow-hidden" data-id="element-84">
      {/* Decorative background blobs */}
      <div className="absolute top-20 left-[-10%] w-[40rem] h-[40rem] bg-coral/20 blob-shape -z-10 blur-3xl" data-id="element-85" />
      <div className="absolute bottom-[-10%] right-[-5%] w-[35rem] h-[35rem] bg-lavender/20 blob-shape -z-10 blur-3xl" style={{
      animationDelay: '-4s'
    }} data-id="element-86" />

      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="max-w-xl order-2 md:order-1" data-id="element-88">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-warmBrown leading-[1.1] mb-6" data-id="element-89">
            Your pet. <br data-id="element-90" />
            <span className="text-peach" data-id="element-91">Your self-care buddy.</span>
          </h1>

          <p className="text-lg md:text-xl text-warmBrown/80 mb-8 leading-relaxed" data-id="element-92">
            Turn your real pet into a cute digital companion. Keep them happy by
            completing daily habits, tracking your mood, and taking moments to
            breathe. Take care of yourself — together.
          </p>

          <div className="flex flex-wrap items-center gap-4" data-id="element-93">
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="px-8 py-4 rounded-full font-bold text-white bg-peach hover:bg-peach/90 shadow-soft-lg flex items-center gap-2" data-id="element-94">
              Get on App Store
            </motion.button>
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="px-8 py-4 rounded-full font-bold text-warmBrown bg-white hover:bg-cream shadow-soft-lg border border-warmBrown/5 flex items-center gap-2" data-id="element-95">
              Get on Google Play
            </motion.button>
          </div>

          

          <div className="mt-6 flex items-center gap-4 text-sm font-medium text-warmBrown/60" data-id="element-96">
            <div className="flex -space-x-2" data-id="element-97">
              {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full bg-coral border-2 border-cream flex items-center justify-center text-xs text-white font-bold" data-id="element-98">
                  {['🐶', '🐱', '🐰', '🐹'][i - 1]}
                </div>)}
            </div>
            <p data-id="element-99">Joined by 10,000+ pet lovers</p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative h-[380px] md:h-[600px] flex justify-center items-center order-1 md:order-2 mt-8 md:mt-0" data-id="element-100">
          {/* Floating elements */}
          <motion.div animate={{
          y: [-10, 10, -10]
        }} transition={{
          repeat: Infinity,
          duration: 4,
          ease: 'easeInOut'
        }} className="absolute top-20 left-10 text-peach" data-id="element-101">
            <Heart size={32} fill="currentColor" data-id="element-102" />
          </motion.div>
          <motion.div animate={{
          y: [10, -10, 10]
        }} transition={{
          repeat: Infinity,
          duration: 5,
          ease: 'easeInOut',
          delay: 1
        }} className="absolute bottom-32 right-10 text-lavender" data-id="element-103">
            <Star size={40} fill="currentColor" data-id="element-104" />
          </motion.div>
          <motion.div animate={{
          y: [-15, 15, -15],
          rotate: [0, 10, 0]
        }} transition={{
          repeat: Infinity,
          duration: 6,
          ease: 'easeInOut',
          delay: 2
        }} className="absolute top-40 right-20 text-4xl" data-id="element-105">
            🐾
          </motion.div>

          {/* Phone Mockup */}
          <div className="relative w-[220px] h-[440px] md:w-[300px] md:h-[600px] bg-warmBrown rounded-[2.2rem] md:rounded-[3rem] shadow-soft-lg border-[3px] border-warmBrown/20 p-[4px] md:p-[6px] overflow-hidden" data-id="element-106">
            {/* Dynamic Island */}
            <div className="absolute top-2 left-1/2 -translate-x-1/2 w-28 h-[22px] bg-black rounded-full z-10" data-id="element-107" />

            {/* Screenshot */}
            <img src="https://cdn.magicpatterns.com/uploads/qmLsMe9BcKw5vU5ocHui9G/Simulator_Screenshot_-_iPhone_16_Pro_-_2026-04-09_at_10.29.48.png" alt="App screenshot showing Kiki the Shih Tzu pet companion with daily tasks" className="w-full h-full object-cover rounded-[2.6rem]" data-id="element-108" />
          </div>
        </motion.div>
      </div>
    </section>;
}